import validateReduxAction from 'modules/redux/actions/validate'
import saveReduxAction from 'modules/redux/actions/save'
import isConnectedTrainingNetworkSelector from 'modules/training/modules/network/selectors/is-connected'
import {
  TRAINING_AUTH_ACTION,
  TRAINING_AUTH_DOMAIN,
  TRAINING_AUTH_ENDPOINT
} from 'modules/training/modules/app-auth/constants'
import getEmailOrNameTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-email-or-name'
import getPasswordTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-password'
import isSignUpTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/is-sign-up'
import afterLogInTrainingAuthAction from 'modules/training/modules/app-auth/actions/after-log-in'
import {
  getCurrentProfileSelect,
  PROFILE_ROLE,
  REDUX_MODEL_KEY,
  USER_KEY
} from '@gymaholic/packages'
import getEmailTrainingAuthSelect from 'modules/training/modules/app-auth/selectors/get-email'
import isEmailStringUtil from 'utils/string/is-email'
import { logUtil } from 'packages/src'
import getProfileDataFromLocalStorageProfileUtil from 'modules/profile/utils/get-profile-data-from-local-storage/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const ANALYTIC_EVENT = {
  SIGN_IN: 'SIGN_IN',
  SIGN_UP: 'SIGN_UP'
}

function logInAppAuthAction ({
  isCreator,
  isOnboarding
}) {
  return async (dispatch, getState) => {
    if (!isConnectedTrainingNetworkSelector()(getState())) {
      return
    }

    dispatch(
      validateReduxAction({
        type: TRAINING_AUTH_ACTION.VALIDATE_EMAIL_AND_PASSWORD,
        payload: {
          path: TRAINING_AUTH_DOMAIN
        }
      })
    )
    const email = getEmailTrainingAuthSelect(getState()).toLowerCase()
    const emailOrName = getEmailOrNameTrainingAuthSelect(getState()).toLowerCase()
    const password = getPasswordTrainingAuthSelect(getState())
    const isSignUp = isSignUpTrainingAuthSelect(getState())
    const remotePath = isSignUp
      ? TRAINING_AUTH_ENDPOINT.SIGN_UP
      : TRAINING_AUTH_ENDPOINT.LOG_IN

    const endpoint = TRAINING_API_ENDPOINT + remotePath
    const data = {
      password
    }

    if (isEmailStringUtil(emailOrName)) {
      data[USER_KEY.EMAIL] = emailOrName
    } else {
      data[USER_KEY.EMAIL] = email
      data[USER_KEY.NAME] = emailOrName
    }

    if (isSignUp && isCreator) {
      data.role = PROFILE_ROLE.CREATOR
    }

    let profile
    if (isOnboarding) {
      profile = getCurrentProfileSelect(getState())
    }
    if (profile) {
      data.profileData = (
        profile?.[REDUX_MODEL_KEY.CHANGED] ||
        getProfileDataFromLocalStorageProfileUtil()
      )
    }

    try {
      const response = await dispatch(
        saveReduxAction({
          type: TRAINING_AUTH_ACTION.LOG_IN,
          payload: {
            data,
            endpoint,
            path: TRAINING_AUTH_DOMAIN
          }
        })
      )

      logEventAnalyticsUtil(isSignUp ? ANALYTIC_EVENT.SIGN_UP : ANALYTIC_EVENT.SIGN_IN)
      return dispatch(afterLogInTrainingAuthAction(response))
    } catch (error) {
      logUtil('logInAppAuthAction').error('error=', error)
    }
  }
}

export default logInAppAuthAction
